/** Profile onboarding requirements — shared by worker and frontend */

export const ONBOARDING_MIN_PHOTOS = 3
export const ONBOARDING_MIN_BIO_LENGTH = 12
/** Maximum public profile photos per member (edit profile; onboarding only requires the minimum). */
export const MAX_PROFILE_PHOTOS = 9

export type OnboardingStepId = 'profile' | 'photos' | 'photos_approved' | 'verified'

export type OnboardingStep = {
  id: OnboardingStepId
  label: string
  done: boolean
  detail: string
}

export type ProfileCompletionSnapshot = {
  percent: number
  complete: boolean
  steps: OnboardingStep[]
  blockers: string[]
  photoCount: number
  approvedPhotoCount: number
  verificationStatus: string
  onboardingCompletedAt: string | null
}

export function emptyCompletion(): ProfileCompletionSnapshot {
  return {
    percent: 0,
    complete: false,
    steps: [],
    blockers: ['Complete setup to use Pairvelle'],
    photoCount: 0,
    approvedPhotoCount: 0,
    verificationStatus: 'none',
    onboardingCompletedAt: null,
  }
}
